import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon, SearchIcon, SparklesIcon, BarChart2Icon, GlobeIcon } from 'lucide-react';
const Hero = () => {
  const chartData = [{
    day: 'Mon',
    score: 62
  }, {
    day: 'Tue',
    score: 65
  }, {
    day: 'Wed',
    score: 68
  }, {
    day: 'Thu',
    score: 71
  }, {
    day: 'Fri',
    score: 74
  }, {
    day: 'Sat',
    score: 79
  }, {
    day: 'Sun',
    score: 84
  }];
  const yLabels = [100, 75, 50, 25, 0];
  return <div className="bg-primary pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-154">
        <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-700 bg-surface text-sm text-textlight mb-8" data-id="element-155">
          <SparklesIcon className="w-4 h-4 text-accent mr-2" data-id="element-156" />
          <span data-id="element-157">AI Search Optimization Platform</span>
        </div>

        <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl lg:text-7xl max-w-4xl mx-auto" data-id="element-158">
          <span className="block mb-2" data-id="element-159">Own Your Brand's Visibility</span>
          <span className="block text-accent" data-id="element-160">in AI Search</span>
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-lg sm:text-xl text-textlight" data-id="element-161">
          Monitor, optimize, and grow your presence across ChatGPT, Perplexity,
          Google AI Overviews, and every AI search engine — all from one
          platform.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4" data-id="element-162">
          <Link to="/demo" className="inline-flex items-center justify-center px-8 py-3.5 border border-transparent text-base font-medium rounded-lg text-white bg-accent hover:bg-cyan-400 transition-colors" data-id="element-163">
            Book a Demo
          </Link>
          <Link to="/platform" className="inline-flex items-center justify-center px-8 py-3.5 border border-gray-600 text-base font-medium rounded-lg text-white hover:bg-surface hover:border-gray-500 transition-colors" data-id="element-164">
            See Platform
          </Link>
        </div>

        {/* Dashboard Mockup */}
        <div className="mt-20 mx-auto max-w-5xl" data-id="element-165">
          <div className="rounded-xl border border-gray-700 bg-surface overflow-hidden flex flex-col md:flex-row h-[480px] text-left" data-id="element-166">
            {/* Sidebar */}
            <div className="hidden md:flex flex-col w-56 bg-primary border-r border-gray-800 p-4" data-id="element-167">
              <div className="flex items-center space-x-2 mb-8 px-2" data-id="element-168">
                <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-169"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-170"></div>
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-171"></div>
              </div>
              <div className="space-y-1" data-id="element-172">
                {[{
                name: 'Overview',
                icon: BarChart2Icon,
                active: true
              }, {
                name: 'Visibility',
                icon: GlobeIcon,
                active: false
              }, {
                name: 'Mentions',
                icon: SearchIcon,
                active: false
              }, {
                name: 'Content',
                icon: SparklesIcon,
                active: false
              }, {
                name: 'Competitors',
                icon: TrendingUpIcon,
                active: false
              }].map(item => <div key={item.name} className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm cursor-default ${item.active ? 'bg-accent/10 text-accent font-medium' : 'text-textlight'}`} data-id="element-173">
                    <item.icon className="w-4 h-4" data-id="element-174" />
                    <span data-id="element-175">{item.name}</span>
                  </div>)}
              </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 p-6 lg:p-8 flex flex-col bg-surface" data-id="element-176">
              {/* Header */}
              <div className="flex justify-between items-start mb-6" data-id="element-177">
                <div data-id="element-178">
                  <p className="text-textlight text-xs font-medium uppercase tracking-wider mb-1" data-id="element-179">
                    Brand Visibility Score
                  </p>
                  <div className="flex items-baseline space-x-2" data-id="element-180">
                    <span className="text-5xl font-bold text-white" data-id="element-181">84</span>
                    <span className="text-lg text-gray-500" data-id="element-182">/100</span>
                  </div>
                </div>
                <div className="flex items-center text-green-400 text-sm font-medium bg-green-400/10 px-3 py-1.5 rounded-md" data-id="element-183">
                  <TrendingUpIcon className="w-3.5 h-3.5 mr-1.5" data-id="element-184" />
                  +12.4%
                </div>
              </div>

              {/* Stat row */}
              <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-185">
                <div className="bg-primary rounded-lg p-3" data-id="element-186">
                  <p className="text-xs text-textlight mb-0.5" data-id="element-187">Mentions</p>
                  <p className="text-lg font-semibold text-white" data-id="element-188">1,247</p>
                </div>
                <div className="bg-primary rounded-lg p-3" data-id="element-189">
                  <p className="text-xs text-textlight mb-0.5" data-id="element-190">Engines</p>
                  <p className="text-lg font-semibold text-white" data-id="element-191">6</p>
                </div>
                <div className="bg-primary rounded-lg p-3" data-id="element-192">
                  <p className="text-xs text-textlight mb-0.5" data-id="element-193">Sentiment</p>
                  <p className="text-lg font-semibold text-green-400" data-id="element-194">92%</p>
                </div>
              </div>

              {/* Chart */}
              <div className="flex-1 flex min-h-0" data-id="element-195">
                {/* Y-axis labels */}
                <div className="flex flex-col justify-between pr-3 pb-6" data-id="element-196">
                  {yLabels.map(label => <span key={label} className="text-xs text-gray-600 tabular-nums leading-none" data-id="element-197">
                      {label}
                    </span>)}
                </div>

                {/* Chart area */}
                <div className="flex-1 flex flex-col min-h-0" data-id="element-198">
                  <div className="flex-1 relative min-h-[120px]" data-id="element-199">
                    {/* Horizontal grid lines */}
                    {yLabels.map((label, i) => <div key={label} className="absolute w-full border-t border-gray-800" style={{
                    top: `${i / (yLabels.length - 1) * 100}%`
                  }} data-id="element-200"></div>)}

                    {/* SVG Line Chart */}
                    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 200" preserveAspectRatio="none" fill="none" data-id="element-201">
                      <defs data-id="element-202">
                        <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1" data-id="element-203">
                          <stop offset="0%" stopColor="#06b6d4" stopOpacity="0.3" data-id="element-204" />
                          <stop offset="100%" stopColor="#06b6d4" stopOpacity="0" data-id="element-205" />
                        </linearGradient>
                      </defs>
                      {/* Area fill */}
                      <path d={`M${chartData.map((d, i) => {
                      const x = i / (chartData.length - 1) * 600;
                      const y = 200 - d.score / 100 * 200;
                      return `${x},${y}`;
                    }).join(' L')} L600,200 L0,200 Z`} fill="url(#areaGradient)" data-id="element-206" />
                      {/* Line */}
                      <polyline points={chartData.map((d, i) => {
                      const x = i / (chartData.length - 1) * 600;
                      const y = 200 - d.score / 100 * 200;
                      return `${x},${y}`;
                    }).join(' ')} stroke="#06b6d4" strokeWidth="3" fill="none" vectorEffect="non-scaling-stroke" data-id="element-207" />
                    </svg>

                    {/* Data point dots */}
                    <div className="absolute inset-0" data-id="element-208">
                      {chartData.map((d, i) => <div key={i} className="absolute w-2.5 h-2.5 bg-accent rounded-full border-2 border-surface" style={{
                      left: `${i / (chartData.length - 1) * 100}%`,
                      top: `${100 - d.score}%`,
                      transform: 'translate(-50%, -50%)'
                    }} data-id="element-209"></div>)}
                    </div>
                  </div>

                  {/* X-axis labels */}
                  <div className="flex justify-between pt-2" data-id="element-210">
                    {chartData.map((d, i) => <span key={i} className="text-xs text-gray-500" data-id="element-211">
                        {d.day}
                      </span>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Hero;